@if(!hideLayout){
<header class="navbar sticky-top bg-dark flex-md-nowrap p-2 shadow" data-bs-theme="dark">
  <a class="navbar-brand col-md-3 col-lg-2 me-0 px-3 fs-6 text-white d-flex" href="#">
    <img src="assets/images/logo.png" height="35">
    <div class="align-self-center">
      TICKETING SYSTEM
    </div>
  </a>
  <div class="lang-switch me-3">
    <button class="m-0" (click)="changeLanguage('en')" [class.active]="currentLang==='en'">EN</button>
    <button class="m-0" (click)="changeLanguage('ar')" [class.active]="currentLang==='ar'">ع</button>
  </div>
</header>
}

<div class="dashboard-layout">
  <app-notification-badge></app-notification-badge>
  @if(!hideLayout){
  <app-app-menu></app-app-menu>
  }

  <main [ngClass]="hideLayout ? 'w-100':'main-content'">
    <router-outlet />
  </main>
</div>

<button class="chat-icon" (click)="goToChat()" *ngIf="!isOnChatPage && !hideLayout">
  <i class="fa fa-comments"></i>
  <span class="message-counter" *ngIf="notificationService.unreadMessageCount() > 0">
    {{ notificationService.unreadMessageCount() }}
  </span>
</button>
